/* eslint-disable */
import $ from 'jquery';
function ModalManager(message) {
  this.handler = function () {
    return message;
  };
  this.active = false;
}
ModalManager.prototype.on = function () {
  if (!this.active) {
    $(window).on('beforeunload', this.handler);
    this.active = true;
  }
};
ModalManager.prototype.off = function () {
  if (this.active) {
    $(window).off('beforeunload', this.handler);
    this.active = false;
  }
};
export default ModalManager;

